import React from "react";
import dynamic from "next/dynamic";
import PropTypes from "prop-types";
import CustomLink from "@/bit/components/components.custom-link";
import CardContent from "./card-content";
const CmsEditableGroupIcons = dynamic(() => import("@/bit/components/components.cms-block.cms-editable-group-icons"));

import { IMAGE_TYPE } from "./enums.js";
import { BEHAVIOUR_KIND } from "@/bit/components/components.custom-link/utils.js";
const TextInfo = dynamic(() => import("@/bit/components/components.text"));

export { IMAGE_TYPE };

const DETAIL_CARD_TAGGING_INFO = {
  componentName: "DetailCard",
  componentVariation: "",
  componentContent: "Modal Ficha",
  eventType: "click",
};

/**
 * Componente que permite crear cards de ofertas
 */
function DetailCard({
  detailCardProps,
  cmsHandler,
  index,
  blockName,
  alias,
  frontalListToDelete,
}) {
  const {
    "cms-atom-link-1": detailCardLink,
    "cms-hiring-details-1": hiringDetails,
    hide,
    inherited,
  } = detailCardProps;
  const cardHasLink =
    detailCardLink && (detailCardLink.href || detailCardLink.onClick);

  // Lógica para que SEO rastree un cms modal ficha cuando la card es clickable
  let hrefSeoElement = "";
  const isCmsModalPageHref =
    detailCardLink?.href?.indexOf(BEHAVIOUR_KIND.CMS_MODAL_PAGE) > -1;
  if (isCmsModalPageHref) {
    hrefSeoElement = detailCardLink.href.replace(
      BEHAVIOUR_KIND.CMS_MODAL_PAGE,
      ""
    );
  }

  if (!detailCardLink.taggingInfo) {
    detailCardLink.taggingInfo = {};
  }

  // LOGICA ENTORNO PRODUCTIVO
  let DetailCardTemplate = cardHasLink ? (
    <>
      {hrefSeoElement && (
        <CustomLink
          {...detailCardLink}
          taggingInfo={{}}
          href={hrefSeoElement}
          style={{ display: "none" }}
        />
      )}
      <CardContent detailCardProps={detailCardProps} />
      <CustomLink
        {...detailCardLink}
        taggingInfo={{
          ...DETAIL_CARD_TAGGING_INFO,
          ...detailCardLink.taggingInfo,
        }}
        className="block-link"
        cydata="DetailCard CustomLink"
      />
    </>
  ) : (
    <CardContent detailCardProps={detailCardProps} />
  );

  // LOGICA ENTORNO CMS
  if (cmsHandler && !inherited) {
    DetailCardTemplate = (
      <>
        {/* Bolitas de edicion aqui */}
        <CmsEditableGroupIcons
          elementProps={{
            ...detailCardProps,
            hiringDetails,
            editName: "cms-block.cms-detail-card",
          }}
          deleteProps={{
            index,
            itemIdDotNotation: `${blockName}.cms-ml-detail-card-1`,
            alias,
            frontalListToDelete
          }}
          visibleTools={{
            hiring: true,
            edit: true,
            deleteItem: true,
          }}
          cmsHandler={cmsHandler}
        />
        <CardContent
          detailCardProps={detailCardProps}
          cmsHandler={cmsHandler}
        />
        <CustomLink
          {...detailCardLink}
          cydata="DetailCard CustomLink"
          cmsHandler={cmsHandler}
        />
      </>
    );
  }

  // LOGICA CARDS HEREDADAS
  if (cmsHandler && inherited) {
    DetailCardTemplate = (
      <>
        {/* Cartel Origen Card al heredar */}
        <div className="inherited-text">
          <TextInfo
            color="white"
            align="center"
            size="t4"
            text={`Esta card pertenece a la ficha ${inherited}. Para cambiar su contenido dirígase a la página correspondiente.`}
          />
        </div>
        <CardContent
          detailCardProps={{ ...detailCardProps, className: "inherited-card" }}
        />
      </>
    );
  }

  const currentClassName = `DetailCard${hide ? " hide" : ""}`;

  return (
    <div className={currentClassName}>
      {DetailCardTemplate}
      <style jsx>{`.DetailCard {
  position: relative;
  height: 100%;
  &.hide {
    display: none;
  }
  :global(.inherited-text) {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(88, 88, 88, 0.7); /* Velo oscuro semitransparente */
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    border-radius: 8px;
    backdrop-filter: blur(4px); /* Difumina el fondo detrás del velo */
  }
  .edit-component {
    border-radius: 16px;
    background: rgba(0, 0, 0, 0.8);
    right: 40px;
    width: 32px;
  }
}
`}</style>
    </div>
  );
}

DetailCard.propTypes = {
  /**
   * {
   *  "info": "Tamaño imagen card",
   *  "kind": "both",
   *  "beautifulName": "ImageSize",
   *  "values": "./enums.js:IMAGE_TYPE"
   * }
   */
  imageSize: PropTypes.string,
  /**
   * {
   *  "info": "Velo para las imágenes",
   *  "kind": "both",
   *  "beautifulName": "Velo",
   *  "values": "./enums.js:SHADOW_TYPE"
   * }
   */
  shadow: PropTypes.string,
  /**
   * {
   *  "info": "Campo para el filtrado de la card, se puede poner un único valor o separar por ',' varios valores",
   *  "kind": "both",
   *  "beautifulName": "Categoria"
   * }
   */
  category: PropTypes.string,
  /**
   * {
   *  "info": "Campo para el ordenado de cards",
   *  "kind": "both",
   *  "beautifulName": "Fecha y hora"
   * }
   */
  datetime: PropTypes.string,
  /**
   * {
   *  "info": "Ocultar card",
   *  "kind": "dev",
   *  "beautifulName": "Ocultar card"
   * }
   */
  hide: PropTypes.bool,
};

DetailCard.defaultProps = {
  imageSize: "",
  shadow: "none",
  category: "todos",
  datetime: "",
  hide: false,
};

export default DetailCard;
